import { get } from 'utils/api';

export const fetchDashboardData = async (params) => {
  return get('/dashboard/', { params });
};

export const dashboardApi = {
  fetchDashboardData,
};

